import React from "react";
import { CardTheme } from "../types";

interface NumberSymbolProps {
  value: number;
  theme: CardTheme;
}

export const NumberSymbol: React.FC<NumberSymbolProps> = React.memo(({ value, theme }) => {
  const { width, height } = theme.card;
  const centerX = width / 2;
  const centerY = height / 2;
  const fontSize = width * 0.3;
  const cornerFontSize = width * 0.12;

  return (
    <>
      {/* Large centered number */}
      <text
        x={centerX}
        y={centerY}
        fontSize={fontSize}
        fontWeight="bold"
        fill={theme.symbol.color}
        textAnchor="middle"
        dominantBaseline="middle"
        fontFamily="Arial, sans-serif"
      >
        {value}
      </text>

      {/* Top-left corner number */}
      <text
        x={width * 0.15}
        y={height * 0.2}
        fontSize={cornerFontSize}
        fontWeight="bold"
        fill={theme.symbol.color}
        textAnchor="middle"
        dominantBaseline="middle"
        fontFamily="Arial, sans-serif"
      >
        {value}
      </text>

      {/* Bottom-right corner number (rotated) */}
      <text
        x={width * 0.85}
        y={height * 0.8}
        fontSize={cornerFontSize}
        fontWeight="bold"
        fill={theme.symbol.color}
        textAnchor="middle"
        dominantBaseline="middle"
        fontFamily="Arial, sans-serif"
        transform={`rotate(180 ${width * 0.85} ${height * 0.8})`}
      >
        {value}
      </text>
    </>
  );
});

NumberSymbol.displayName = "NumberSymbol";
